export const TEXT_ASSET_TYPES = [
  { value: 'HEADLINE', label: 'Headline', minCount: 3, maxCount: 15, maxLength: 30 },
  { value: 'LONG_HEADLINE', label: 'Long Headline', minCount: 1, maxCount: 5, maxLength: 90 },
  { value: 'DESCRIPTION', label: 'Description', minCount: 2, maxCount: 5, maxLength: 90 },
  { value: 'BUSINESS_NAME', label: 'Business Name', minCount: 1, maxCount: 1, maxLength: 25 },
];

export const IMAGE_ASSET_TYPES = [
  {
    value: 'MARKETING_IMAGE',
    label: 'Marketing Image',
    minCount: 1,
    maxCount: 20,
    aspectRatio: 1.91,
    aspectRatioLabel: '1.91:1',
    minWidth: 600,
    minHeight: 314,
    recommendedDimensions: '1200×628',
  },
  {
    value: 'SQUARE_MARKETING_IMAGE',
    label: 'Square Image',
    minCount: 1,
    maxCount: 20,
    aspectRatio: 1,
    aspectRatioLabel: '1:1',
    minWidth: 300,
    minHeight: 300,
    recommendedDimensions: '1200×1200',
  },
  {
    value: 'LOGO',
    label: 'Logo',
    minCount: 1,
    maxCount: 5,
    aspectRatio: 1,
    aspectRatioLabel: '1:1',
    minWidth: 128,
    minHeight: 128,
    recommendedDimensions: '1200×1200',
  },
];

export const REQUIRED_ASSET_ROWS = [
  { type: 'TEXT', fieldType: 'HEADLINE' },
  { type: 'TEXT', fieldType: 'HEADLINE' },
  { type: 'TEXT', fieldType: 'HEADLINE' },
  { type: 'TEXT', fieldType: 'LONG_HEADLINE' },
  { type: 'TEXT', fieldType: 'DESCRIPTION' },
  { type: 'TEXT', fieldType: 'DESCRIPTION' },
  { type: 'TEXT', fieldType: 'BUSINESS_NAME' },
  { type: 'IMAGE', fieldType: 'MARKETING_IMAGE' },
  { type: 'IMAGE', fieldType: 'SQUARE_MARKETING_IMAGE' },
  { type: 'IMAGE', fieldType: 'LOGO' },
];
